import { createContext } from 'react'

export const Notifications = createContext()
